import React from "react";
import usePagination from "../../../../hooks/usePagination";

function Pagenation({
  setCurrentPage,
  currentPage = 1,
  pages = 1,
  totalList = 0,
  itemsPerPage,
}) {
  const normalizedPages = Math.max(1, pages);
  const normalizedCurrent = Math.min(Math.max(currentPage, 1), normalizedPages);

  const { currentThree, next, prev, jump } = usePagination({
    setCurrentPage,
    currentPage: normalizedCurrent,
    maxPage: normalizedPages,
  });

  // Use itemsPerPage if provided, otherwise calculate from pages
  const computedPerPage = itemsPerPage
    ? itemsPerPage
    : normalizedPages > 0
    ? Math.ceil(totalList / normalizedPages || 1)
    : totalList;
  const startItem =
    totalList === 0 ? 0 : (normalizedCurrent - 1) * computedPerPage + 1;
  const endItem = Math.min(totalList, startItem + computedPerPage - 1);

  // Build pagination with first page, current window, and last page
  const buildPaginationPages = () => {
    if (normalizedPages <= 1) return [1];
    if (normalizedPages <= 5) {
      // If 5 pages or less, show all pages
      return Array.from({ length: normalizedPages }, (_, i) => i + 1);
    }

    const pages = [];
    const firstPage = 1;
    const lastPage = normalizedPages;
    const showFirst = !currentThree.includes(firstPage);
    const showLast = !currentThree.includes(lastPage);
    const showFirstEllipsis = showFirst && currentThree[0] > firstPage + 1;
    const showLastEllipsis = showLast && currentThree[currentThree.length - 1] < lastPage - 1;

    // Add first page
    if (showFirst) {
      pages.push(firstPage);
    }

    // Add ellipsis after first page if needed
    if (showFirstEllipsis) {
      pages.push("ellipsis-start");
    }

    // Add current window pages
    currentThree.forEach((page) => {
      if (!pages.includes(page)) {
        pages.push(page);
      }
    });

    // Add ellipsis before last page if needed
    if (showLastEllipsis) {
      pages.push("ellipsis-end");
    }

    // Add last page
    if (showLast) {
      pages.push(lastPage);
    }

    return pages;
  };

  const renderPages = buildPaginationPages();

  return (
    <div className="d-flex justify-content-between pagination">
      <div>
        <span className="page-number">
          {totalList > 0
            ? `Showing ${startItem}-${endItem} of ${totalList} items`
            : "No data"}
        </span>
      </div>
      {normalizedPages > 1 ? (
        <div className="d-flex ">
          <span onClick={prev} className="pointerPagination">
            Previous
          </span>
          <ul>
            {renderPages.map((page, index) => {
              if (page === "ellipsis-start" || page === "ellipsis-end") {
                return (
                  <li key={`ellipsis-${index}`} className="page ellipsis" style={{ cursor: "default" }}>
                    ...
                  </li>
                );
              }
              return (
                <li
                  key={page}
                  className={normalizedCurrent === page ? "active-page" : "page"}
                  onClick={() => jump(page)}
                >
                  {page}
                </li>
              );
            })}
          </ul>
          <span onClick={next} className="pointerPagination">
            Next
          </span>
        </div>
      ) : (
        <div className="d-flex disablePagination">
          <span>Previous</span>
          <ul>
            <li key="1" className="active-page">
              1
            </li>
          </ul>
          <span>Next</span>
        </div>
      )}
    </div>
  );
}

export default Pagenation;
